export default function Button({ text, category = 'primary', onClick, type = 'button', active = true }) {
  const baseClasses = 'py-3 font-bold transition';
  const activeClasses = active
    ? 'bg-yellow text-text-light hover:opacity-90'
    : 'bg-gray text-darkgray opacity-60';
  const variants = {
    primary: 'px-6 rounded-2xl border-b-4 border-r-4 border-orange',
    searchbar: 'px-6 rounded-r-xl hidden sm:inline',
    searchbarsmall: 'px-6 rounded-r-xl inline sm:hidden',
    gamebar: 'px-6 rounded-tr-xl hidden sm:inline',
    gamebarsmall: 'px-2 rounded-tr-xl inline sm:hidden',
  };

  return (
    <button
      title={text}
      type={type}
      className={`${baseClasses} ${activeClasses} ${variants[category]}`}
      onClick={onClick}
      disabled={!active}
    >
      {text}
    </button>
  );
}
